import React, { useEffect, useState } from "react";
import { memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import newsService from "../../../../services/news.service";
import NewsContent from "./NewsContent";

const NewsDetail = memo(() => {
  const { id } = useParams<{ id: string }>();
  const [newDetail, setNewDetail] = useState<any>(null); // State lưu thông tin bài viết
  const [loading, setLoading] = useState<boolean>(true); // Loading state
  const [error, setError] = useState<string>(""); // Error state
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      newsService
        .fetchNewsDetail(id)
        .then((data) => {
          setNewDetail(data); // Lưu dữ liệu vào state
          setLoading(false); // Dừng loading khi có dữ liệu
        })
        .catch((err) => {
          setError("Failed to fetch news detail");
          setLoading(false);
        });
    }
  }, [id]);
  return (
    <div>
      <div
        style={{
          padding: "10px 16px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          onClick={() => navigate("/news/list")}
          style={{
            cursor: "pointer",
            fontSize: 18,
            fontWeight: "bold",
            marginRight: 16,
          }}
        >
          &lt;
        </div>
        <div
          style={{
            flex: 1,
            textAlign: "center",
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          Tin tức
        </div>
        <div
          style={{ width: 24 /* giữ khoảng trống bằng mũi tên để canh giữa */ }}
        />
      </div>
      <NewsContent newDetail={newDetail} />
    </div>
  );
});

export default NewsDetail;
